import { useEffect, useState } from 'react';

export const useScreenWidth = () => {
    const [screenWidth, setScreenWidth] = useState<number>(0);
    useEffect(() => {
        setScreenWidth(window.innerWidth);
        window.addEventListener('resize', () => setScreenWidth(window.innerWidth));
    }, []);
    return screenWidth;
};
